import { styled } from '@mui/material';

const Section7Container = styled('section')(({ theme }) => ({
  maxWidth: 1500,
  margin: '0 auto',
  display: 'flex',
  width: '100%',
  gap: 120,
  padding: '48px 64px',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    padding: 0,
  },
  '& div.content': {
    flexBasis: '50%',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      order: 2,
      padding: '0 32px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0 1rem',
    },
    '& div.header': {
      maxWidth: 526,
      marginBottom: 32,
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      gap: 32,
      [theme.breakpoints.down('lg')]: {
        padding: '0 32px',
      },
      svg: {
        height: 100,
        width: 100,
      },
      h2: {
        fontSize: 32,
        fontWeight: 700,
        lineHeight: '48px',
        color: '#04246B',
      },
    },
    p: {
      maxWidth: 526,
      fontSize: 18,
      lineHeight: '28px',
      textAlign: 'justify',
      [theme.breakpoints.down('md')]: {
        textAlign: 'center',
      },
    },
  },
  '& div.image': {
    flexBasis: '50%',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      order: 1,
      marginTop: -80,
    },
    img: {
      maxWidth: '100%',
      borderRadius: 16,
      height: 728,
      objectFit: 'cover',
      boxShadow: '16px 8px 48px 0px rgba(0, 0, 0, 0.25)',
      [theme.breakpoints.down('md')]: {
        borderRadius: 0,
        height: 400,
        width: '100vw',
      },
    },
  },
}));

const Section7 = () => {
  return (
    <Section7Container>
      <div className="content">
        <div className="header">
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="101" viewBox="0 0 100 101" fill="none">
            <circle cx="50" cy="51" r="48.5" fill="white" stroke="#CDA07D" stroke-width="3" />
            <path
              d="M30.625 31C29.1332 31 27.7024 31.5926 26.6475 32.6475C25.5926 33.7024 25 35.1332 25 36.625V42.875C25 44.3668 25.5926 45.7976 26.6475 46.8525C27.7024 47.9074 29.1332 48.5 30.625 48.5H36.875C38.3668 48.5 39.7976 47.9074 40.8525 46.8525C41.9074 45.7976 42.5 44.3668 42.5 42.875V36.625C42.5 35.1332 41.9074 33.7024 40.8525 32.6475C39.7976 31.5926 38.3668 31 36.875 31H30.625ZM48.125 33.5C47.6277 33.5 47.1508 33.6975 46.7992 34.0492C46.4475 34.4008 46.25 34.8777 46.25 35.375C46.25 35.8723 46.4475 36.3492 46.7992 36.7008C47.1508 37.0525 47.6277 37.25 48.125 37.25H73.125C73.6223 37.25 74.0992 37.0525 74.4508 36.7008C74.8025 36.3492 75 35.8723 75 35.375C75 34.8777 74.8025 34.4008 74.4508 34.0492C74.0992 33.6975 73.6223 33.5 73.125 33.5H48.125ZM48.125 41C47.6277 41 47.1508 41.1975 46.7992 41.5492C46.4475 41.9008 46.25 42.3777 46.25 42.875C46.25 43.3723 46.4475 43.8492 46.7992 44.2008C47.1508 44.5525 47.6277 44.75 48.125 44.75H65.625C66.1223 44.75 66.5992 44.5525 66.9508 44.2008C67.3025 43.8492 67.5 43.3723 67.5 42.875C67.5 42.3777 67.3025 41.9008 66.9508 41.5492C66.5992 41.1975 66.1223 41 65.625 41H48.125ZM30.625 53.5C29.1332 53.5 27.7024 54.0926 26.6475 55.1475C25.5926 56.2024 25 57.6332 25 59.125V65.375C25 66.1137 25.1455 66.8451 25.4282 67.5276C25.7109 68.2101 26.1252 68.8301 26.6475 69.3525C27.1699 69.8748 27.7899 70.2891 28.4724 70.5718C29.1549 70.8545 29.8863 71 30.625 71H36.875C37.6137 71 38.3451 70.8545 39.0276 70.5718C39.7101 70.2891 40.3301 69.8748 40.8525 69.3525C41.3748 68.8301 41.7891 68.2101 42.0718 67.5276C42.3545 66.8451 42.5 66.1137 42.5 65.375V59.125C42.5 57.6332 41.9074 56.2024 40.8525 55.1475C39.7976 54.0926 38.3668 53.5 36.875 53.5H30.625ZM48.125 56C47.6277 56 47.1508 56.1975 46.7992 56.5492C46.4475 56.9008 46.25 57.3777 46.25 57.875C46.25 58.3723 46.4475 58.8492 46.7992 59.2008C47.1508 59.5525 47.6277 59.75 48.125 59.75H73.125C73.6223 59.75 74.0992 59.5525 74.4508 59.2008C74.8025 58.8492 75 58.3723 75 57.875C75 57.3777 74.8025 56.9008 74.4508 56.5492C74.0992 56.1975 73.6223 56 73.125 56H48.125ZM48.125 63.5C47.6277 63.5 47.1508 63.6975 46.7992 64.0492C46.4475 64.4008 46.25 64.8777 46.25 65.375C46.25 65.8723 46.4475 66.3492 46.7992 66.7008C47.1508 67.0525 47.6277 67.25 48.125 67.25H65.625C66.1223 67.25 66.5992 67.0525 66.9508 66.7008C67.3025 66.3492 67.5 65.8723 67.5 65.375C67.5 64.8777 67.3025 64.4008 66.9508 64.0492C66.5992 63.6975 66.1223 63.5 65.625 63.5H48.125Z"
              fill="#CDA07D"
            />
          </svg>
          <h2>Details Matter</h2>
        </div>
        <p style={{ marginBottom: 40 }}>
          Navigating the intricacies of a home sale is no small feat, and at The New Home Collection, we've implemented
          a state-of-the-art transaction management system to ensure every step is seamless. Our platform prioritizes
          organization and meticulous attention to detail — two pivotal aspects often overlooked in the home selling
          process. From the initial listing to the final paperwork, every detail is systematically logged, tracked, and
          managed. By centralizing all aspects of the transaction, our system reduces the chances of oversight and
          miscommunication.
        </p>
        <p>
          The importance of organization cannot be stressed enough; one minor oversight can lead to significant delays
          or contractual issues. With The New Home Collection's unwavering commitment to precision and its robust
          transaction management, sellers are guaranteed a smooth and efficient experience, ensuring that every 'i' is
          dotted and every 't' is crossed in the complex journey of selling a home.
        </p>
      </div>
      <div className="image">
        <img
          src="https://bucket.ywhdev.com/wl/?id=MeEZVYyX5b80vNez5mqObVb9vxwp0PY2&fmode=open"
          alt="showing a beautiful 2-storey house."
        />
      </div>
    </Section7Container>
  );
};

export default Section7;
